import { HIDDEN_KEYBOARD_KEYS_LICENCE_PLATE } from '../components/Keyboard'

export const validateKeyboardInput = (
  value: string,
  options: { numeric?: boolean; alphabet?: boolean; hideKeys?: boolean, countries?: boolean },
): boolean | null => {
  const hiddenSymbols = !options.hideKeys
    ? HIDDEN_KEYBOARD_KEYS_LICENCE_PLATE.map((item) => (item === '-' ? '\\-' : item)).join('')
    : ''
    if (value === '') {
      return true
    } else if (options.alphabet && options.numeric) {
      const alphanumericPattern = new RegExp(`^[a-zA-Z0-9üõöäåÜÕÖÄÅ${hiddenSymbols}]+$`)
      return alphanumericPattern.test(value)
    } else if (options.alphabet) {
      const alphabetPattern = new RegExp(`^[a-zA-ZüõöäåÜÕÖÄÅ${hiddenSymbols}]+$`)
      return alphabetPattern.test(value)
    } else if (options.countries) {
      const countriesPattern = new RegExp(`^[a-zA-ZüõöäåÜÕÖÄÅ'&\\(\\)\\- ]+$`)
      return countriesPattern.test(value)
    } else if (options.numeric) {
    const numericPattern = /^[0-9]+$/
    return numericPattern.test(value)
  }
  return null
}
